export const messagesSpots = {
    pt: {
        message:{
            actionIrreversible: "Esta ação é irreversível",
            activate: "Ativar",
            accessPointGroup: "Grupo de AP",
            category: "Categoria",
            connectionTimeout: "Tempo de Conexão",
            continueDeviceCreationQuestion: "Continuar a criação do aparelho?",
            continueDeviceCreationExplanation: "Caso você faça a inserção desse aparelho e já tenha ultrapassado o limite de licenças contratadas, você pode ter uma cobrança adicional no próximo mês.",
            controller: "Controladora",
            controllerRegistration: "Registro Controladora",
            controllerType: "Tipo de Controladora",
            controllers: "Controladoras",
            controllersRegistration: "Registro Controladoras",
            create: "Criar",
            deleteController: "Deletar Controladora",
            deleteControllerConfirmation: "Quer mesmo deletar esta controladora? Esta ação é irreversível",
            deleteThis: "Quer mesmo deletar este",
            device: "Aparelho",
            devices: "Aparelhos",
            deviceKey: "Chave do Aparelho",
            deviceName: "Nome do Aparelho",
            deviceType: "Tipo do Aparelho",
            disableWifeed: "Inativar WiFeed",
            disableWifeedConfirmation: "Quer mesmo inativar o WiFeed nesse local? As campanhas irão parar de ser veiculadas.",
            domain: "Domínio",
            domainFailover: "Domínio Failover",
            siteId: "Controller Site Id",
            downloadConfigFiles: "Baixar arquivos de configuração",
            hour: 'HORA',
            linkSpot: "Vincular Local",
            loadMore: "Carregar mais",
            login: "Login",
            minute: "MINUTO",
            newDevice: "Novo Aparelho",
            newGroup: "Novo Grupo",
            newSpot: "Novo Local",
            no: "NÃO",
            noControllerRegistered: "Nenhuma controlodora cadastrada",
            observations: "Anotações",
            over18YearsOld: "Somente maiores de 18 anos",
            password: "Senha",
            port: "Porta",
            portFailover: "Porta Failover",
            registerNewController: "Cadastrar nova controladora",
            registerSpot: "Registrar Local",
            registerSpotsGroup: "Registrar Grupo de Locais",
            removeConfirmation: "Você tem certeza que deseja remover?",
            select: "Selecione",
            serverAddress: "Server address",
            serverApiLogin: "Server API Login",
            serverApiPassword: "Server API Senha",
            serverApiPort: "Server API Port",
            serverVpnPort: "Server VPN Port",
            setDefaultController: "Definir como controladora padrão",
            setDefaultCaptiveLogin: "Definir como Formulário padrão",
            spot: "Local",
            spotName: "Nome do Local",
            spotsGroup: "Grupo de Locais",
            standard: "Padrão",
            supportConnection: "Conexão para Suporte",
            test: "Testar",
            testFailover: "Testar Failover",
            timeNextAccess: "Bloqueio até o próximo acesso",
            timeout: "Tempo",
            timezone: "Fuso Horário",
            vpn: "VPN",
            vpnAuth: "VPN Auth",
            vpnCypher: "VPN Cipher",
            vpnRegistration: "Registro de VPN",
            yes: "SIM"

        }
    },
    es: {
        message:{
            actionIrreversible:"Esta acción es irreversible",
            activate:"Activar",
            accessPointGroup:"Grupo AP",
            category: "Categoria",
            connectionTimeout:"Tiempo de conección",
            continueDeviceCreationQuestion: "¿Continuar creando el dispositivo?",
            continueDeviceCreationExplanation: "Si insertas este dispositivo y ya has superado el límite de licencia contratado, es posible que incurras en un cargo adicional el próximo mes.",
            controller:"Controlador",
            controllerRegistration:"Control de registro",
            controllerType:"Tipo de controlador",
            controllers:"Controlador",
            controllersRegistration:"Control de registro",
            create:"Crear",
            deleteController:"Eliminar controlador",
            deleteControllerConfirmation:"¿De verdad quieres eliminar este controlador? Esta acción es irreversible",
            deleteThis:"Realmente quiero eliminar esto",
            device:"Dispositivo",
            devices:"Dispositivos",
            deviceKey:"Clave del dispositivo",
            deviceName:"Nombre del dispositivo",
            deviceType:"Tipo de dispositivo",
            disableWifeed:"Inactivar esposa",
            disableWifeedConfirmation:"¿Realmente quieres inactivar WiFeed en este lugar? Las campañas dejarán de ser emitidas",
            domain:"Dominio",
            domainFailover: "Dominio Failover",
            siteId: "Controller Site Id",
            downloadConfigFiles:"Descargar archivos de configuración",
            hour:"HORA",
            linkSpot:"Enlace local",
            loadMore:"Carga más",
            login:"Acceso",
            minute:"MINUTO",
            newDevice:"Nuevo dispositivo",
            newGroup:"Nuevo grupo",
            newSpot:"Nueva ubicacion",
            no:"NO",
            noControllerRegistered:"No controlador registrado",
            observations:"Notas",
            over18YearsOld:"Solo más de 18 años",
            password:"Contraseña",
            port:"Puerto",
            portFailover: "Puerto Failover",
            registerNewController:"Registre un nuevo controlador",
            registerSpot:"Registro de ubicación",
            registerSpotsGroup:"Registre el grupo de ubicaciones",
            removeConfirmation:"¿Estás seguro de que desea eliminar?",
            select:"Seleccione",
            serverAddress:"Dirección del servidor",
            serverApiLogin:"Inicio de sesión de la API del servidor",
            serverApiPassword:"Contraseña de API del servidor",
            serverApiPort:"Puerto API del servidor",
            serverVpnPort:"Puerto VPN del servidor",
            setDefaultController:"Definir como controlador estándar",
            setDefaultCaptiveLogin:"Definir como forma estándar",
            spot:"Lugar",
            spotName:"Nombre local",
            spotsGroup:"Grupo de lugares",
            standard:"Patrón",
            supportConnection:"Conexión de soporte",
            test:"Prueba",
            testFailover: "Prueba Failover",
            timeNextAccess: "Bloqueo hasta el próximo acceso",
            timeout:"Hora",
            timezone:"Huso horario",
            vpn:"VPN",
            vpnAuth:"Auth VPN",
            vpnCypher:"VPN CIPHER",
            vpnRegistration:"Registro de VPN",
            yes:"SI"
        }
    },
    en: {
        message:{
            actionIrreversible: "This action is irreversible",
            activate: "Activate",
            accessPointGroup: "AP Group",
            category: "Category",
            connectionTimeout: "Connection Time",
            continueDeviceCreationQuestion: "Continue creating the device?",
            continueDeviceCreationExplanation: "If you insert this device and have already exceeded the contracted license limit, you may incur an additional charge the next month.",
            controller: "Controller",
            controllerRegistration: "Controller Registration",
            controllerType: "Controller Type",
            controllers: "Controllers",
            controllersRegistration: "Controllers Registration",
            create: "Create",
            deleteController: "Delete Controller",
            deleteControllerConfirmation: "Do you really want to delete this controller? This action is irreversible",
            deleteThis: "Do you really want to delete this",
            device: "Device",
            devices: "Devices",
            deviceKey: "Device key",
            deviceName: "Device name",
            deviceType: "Device type",
            disableWifeed: "Disable WiFeed",
            disableWifeedConfirmation: "Do you really want to disable WiFeed in that spot? Campaigns will stop running.",
            domain: "Domain",
            domainFailover: "Domain Failover",
            siteId: "Controller Site Id",
            downloadConfigFiles: "Download configuration files",
            hour: 'HOUR',
            linkSpot: "Link Spot",
            loadMore: "Load more",
            login: "Login",
            minute: "MINUTE",
            newDevice: "New Device",
            newGroup: "New Group",
            newSpot: "New Spot",
            no: "NO",
            noControllerRegistered: "No controller registered",
            observations: "Observations",
            over18YearsOld: "Only over 18 years old",
            password: "Password",
            port: "Port",
            portFailover: "Port Failover",
            registerNewController: "Register new controller",
            registerSpot: "Register Spot",
            registerSpotsGroup: "Register Spots Group",
            removeConfirmation: "Are you sure you want to remove?",
            select: "Select",
            serverAddress: "Server address",
            serverApiLogin: "Server API Login",
            serverApiPassword: "Server API Password",
            serverApiPort: "Server API Port",
            serverVpnPort: "Server VPN Port",
            setDefaultController: "Set as default controller",
            setDefaultCaptiveLogin: "Set as default form",
            spot: "Spot",
            spotName: "Spot name",
            spotsGroup: "Spots Group",
            standard: "Standard",
            supportConnection: "Support Connection",
            test: "Test",
            testFailover: "Failover Test",
            timeNextAccess: "Blocking until next access",
            timeout: "Timeout",
            timezone: "Timezone",
            vpn: "VPN",
            vpnAuth: "VPN Auth",
            vpnCypher: "VPN Cipher",
            vpnRegistration: "VPN registration",
            yes: "YES"


        }
    }
}
